import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseComponent } from 'src/app/core/base.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { SessionService } from 'src/app/shared/services/session.service';
import { Course } from '../course';
import { CourseService } from '../course.service';

@Component({
    selector: 'app-course-create',
    templateUrl: './course-create.component.html',
    styleUrls: ['./course-create.component.scss'],
    standalone: false
})
export class CourseCreateComponent extends BaseComponent implements OnInit {
  public courseForm = new FormBuilder().group({
    name: new FormControl('', {
      validators: Validators.required
    }),
    shortName: new FormControl('', {
      validators: Validators.required
    }),
    address: new FormControl('', {
      validators: Validators.required
    }),
    city: new FormControl('', {
      validators: Validators.required
    }),
    state: new FormControl('', {
      validators: Validators.required
    }),
    zipCode: new FormControl('', {
      validators: Validators.required
    }),
    country: new FormControl('United States', {
      validators: Validators.required
    }),
    isPrivate: new FormControl(false, {
      validators: Validators.required
    }),
    createdBy: new FormControl(),
    teeboxes: new FormBuilder().array([{
      id: new FormControl(),
      course: new FormControl(),
      teebox: new FormControl('', {
        validators: Validators.required
      }),
      yardage: new FormControl(0, {
        validators: Validators.required
      }),
      holes: new FormBuilder().array([{
        color: new FormControl(),
        holeNumber: new FormControl(0, {
          validators: Validators.required
        }),
        par: new FormControl(0, {
          validators: Validators.required
        }),
        yards: new FormControl(0, {
          validators: Validators.required
        }),
        handicap: new FormControl(0, {
          validators: Validators.required
        })
      }])
    }])
  });

  get teeboxes(): FormArray {
    return this.courseForm.get('teeboxes') as FormArray;
  }

  get holes(): FormArray {
    return this.teeboxes.controls[this.selected.value - 1].get('holes') as FormArray;
  }

  selected = new FormControl(0);

  constructor(public sessionService: SessionService,
    private courseService: CourseService,
    stringHelpers: StringHelpers,
    private router: Router,
    private formBuilder: FormBuilder) {
    super(sessionService, stringHelpers);
  }

  ngOnInit(): void {
    this.teeboxes.clear();
  }

  addTeebox() {
    this.teeboxes.push(this.newTeebox());
    this.selected.setValue(this.teeboxes.length);
    this.addHoles();
  }

  removeTeebox(index) {
    this.teeboxes.removeAt(index);
  }

  newTeebox() {
    return this.formBuilder.group({
      id: new FormControl(),
      teebox: new FormControl('', {
        validators: Validators.required
      }),
      yardage: '',
      holes: this.formBuilder.array([{
        holeNumber: new FormControl(0, {
          validators: Validators.required
        }),
        par: new FormControl(0, {
          validators: Validators.required
        }),
        yards: new FormControl(0, {
          validators: Validators.required
        }),
        handicap: new FormControl(0, {
          validators: Validators.required
        })
      }])
    });
  }

  addHoles() {
    this.holes.clear();
    this.newNineHoles();
  }

  newNineHoles() {
    for (let index = 1; index <= 9; index++) {
      this.holes.push(this.formBuilder.group({
        holeNumber: new FormControl(index, {
          validators: Validators.required
        }),
        par: new FormControl(0, {
          validators: Validators.required
        }),
        yards: new FormControl(0, {
          validators: Validators.required
        }),
        handicap: new FormControl(0, {
          validators: Validators.required
        })}
      ));
    }
  }

  createTeebox(data){
    let k = 2;
  }

  calculateYardage(teebox){

  }

  submit({ value, valid }) {
    if (valid) {
      this.isLoading = true;
      value.createdBy = this.sessionService.getUserId();
      this.courseService.create(value).subscribe((results: Course) => {
        this.isLoading = false;
        this.courseForm.reset();
        this.courseForm.clearAsyncValidators();
        this.courseForm.clearValidators();
        this.isLoading = false;
        this.router.navigate(['course', 'details', results.id]);
      }, (err: any) => {
        this.isLoading = false;
        this.setError(err, this.courseForm);
      });
    }
  }
}
